import { html } from "lit-html";
import i18next from "i18next";
export function Home() {
  return html` <div class="p-4 font-semibold">${i18next.t("Welcome")}</div> `;
}
